import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessUserRolesState from '../reducers';
import * as businessUserRolesReducer from '../reducers/business-user-role.reducer';

export const selectBusinessUserRole = createSelector(
  businessUserRolesState.GetBusinessUserRolesState,
  businessUserRolesReducer.getBusinessUserRoles
);
